import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import VenueMasterInput from "../../../components/VenueMasterInput/VenueMasterInput";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import {
  getOneVenueMaster,
  fetchDeckList,
} from "../../../utils/ApiCalls/Mobile/VenueMaster";

const EditVenueMaster = () => {
  const params = useParams();
  const [venues, setVenues] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Venues",
      route: "/shore/mobile-masters/venue",
    },
    {
      title: "Edit Venues",
      route: "/shore/mobile-masters/venue/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getOneVenueMaster(value);

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });

    setVenues(data.data);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Venues"}>
      <CustomHeaderTitle title={"Edit Venues"} />
      <HeaderBread navigation={navigation} title={"Edit Venues"}></HeaderBread>
      {venues && <VenueMasterInput venues={venues} />}
    </Layout>
  );
};

export default EditVenueMaster;
